// extracted by mini-css-extract-plugin
module.exports = {"root":"heading_root__3gBGh","subTitle":"heading_subTitle__3PrG8"};